import type { ReactNode } from 'react'

import { BaseList } from '../base-list'
import type { Variant } from '../list.context'

type Props = {
  variant?: Variant
  children: ReactNode
  className?: string
}

export const NumberedList = ({
  variant = 'medium',
  children,
  className,
}: Props) => (
  <BaseList
    className={className}
    component="ol"
    data-testid="numbered-list"
    variant={variant}
  >
    {children}
  </BaseList>
)
